import { createContext } from 'react';

export const LoadContext = createContext({"value":0,"token":""});
